import { useQuery } from "@tanstack/react-query";

import { GO_HIRE_QUERY_KEYS } from "../queryKeys";
import { getHireJobs, GetHireJobsFilters } from "../services/job.services";

export type { GetHireJobsFilters };

export const useGetHireJobs = (filters?: GetHireJobsFilters) => {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: GO_HIRE_QUERY_KEYS.jobsList(filters),
    queryFn: () => getHireJobs(filters),
  });

  return {
    data,
    isLoading,
    isError,
    error,
    refetch,
  };
};

export const useHasHireJobs = () => {
  const { data, isLoading } = useGetHireJobs({});
  return {
    hasHireJobs: data?.items && data?.items?.length > 0,
    isLoading,
  };
};
